export default "__VITE_ASSET__pJdwnaVr__"